"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingConfiguration = exports.AccountingConfigrationPresetType = void 0;
const typeorm_1 = require("typeorm");
const address_1 = require("../address");
var AccountingConfigrationPresetType;
(function (AccountingConfigrationPresetType) {
    AccountingConfigrationPresetType["ACTIVE"] = "active";
    AccountingConfigrationPresetType["INACTIVE"] = "inactive";
})(AccountingConfigrationPresetType = exports.AccountingConfigrationPresetType || (exports.AccountingConfigrationPresetType = {}));
let AccountingConfiguration = class AccountingConfiguration {
};
__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({
        type: 'bigint',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "id", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: AccountingConfigrationPresetType,
        nullable: false,
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "configurationType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "invoiceNumberTemplate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "creditNoteNumberTemplate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "cancellationNumberTemplate", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyDirector", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyHeadquarters", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyTaxNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        default: '',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyVatId", void 0);
__decorate([
    (0, typeorm_1.Column)((type) => address_1.Address, {
        prefix: 'company_address',
    }),
    __metadata("design:type", address_1.Address)
], AccountingConfiguration.prototype, "companyAddress", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyEmail", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyPhone", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyBankName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyIban", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "companyBic", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "factoringAccountOwner", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "factoringBankName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "factoringIban", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        nullable: true,
    }),
    __metadata("design:type", String)
], AccountingConfiguration.prototype, "factoringBic", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], AccountingConfiguration.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        type: 'timestamp with time zone',
    }),
    __metadata("design:type", Date)
], AccountingConfiguration.prototype, "updatedAt", void 0);
AccountingConfiguration = __decorate([
    (0, typeorm_1.Entity)('configuration', { schema: 'accounting' })
], AccountingConfiguration);
exports.AccountingConfiguration = AccountingConfiguration;
//# sourceMappingURL=accounting-configuration.js.map